module.exports = __webpack_public_path__ + "static/media/blingV3_6.dc5c270c.png";